import {
  CoreApi,
  ImageType,
  Product,
  ProductDesign,
  ProductImageDetails
} from '@inter-ikea-storageone/range';
import BirchCornerFrame from '../images/corner_birch.jpg';
import BlackOakCornerFrame from '../images/corner_blackOak.jpg';
import BrownWalnutCornerFrame from '../images/corner_brownWalnut.jpg';
import DarkBrownOakCornerFrame from '../images/corner_darkBrownOak.jpg';
import OakCornerFrame from '../images/corner_oak.jpg';
import WhiteCornerFrame from '../images/corner_white.jpg';
import { getMPPImage } from 'products';
import { ComponentIds, GuestConnectionsComponent } from '@inter-ikea-core/core';

export const getCustomCornerFrameImage = (src: string): ProductImageDetails => {
  return {
    id: '1',
    sources: [{ src, width: 100, height: 100 }],
    type: ImageType.MPP
  };
};

export const getCornerFrameImage = (product: Product) => {
  const design = product.design;
  switch (design) {
    case ProductDesign.WHITE:
      return getCustomCornerFrameImage(WhiteCornerFrame);
    case ProductDesign.BIRCH:
      return getCustomCornerFrameImage(BirchCornerFrame);
    case ProductDesign.BLACK_OAK:
      return getCustomCornerFrameImage(BlackOakCornerFrame);
    case ProductDesign.BROWN_WALNUT_EFFECT:
      return getCustomCornerFrameImage(BrownWalnutCornerFrame);
    case ProductDesign.DARK_BROWN_OAK:
      return getCustomCornerFrameImage(DarkBrownOakCornerFrame);
    case ProductDesign.OAK:
      return getCustomCornerFrameImage(OakCornerFrame);
    default:
      return getMPPImage(product);
  }
};

export const placedInCorner = (product: Product, coreApi: CoreApi) => {
  const entitiesOfProductInScene = coreApi.entities
    .getAll()
    .filter(e => coreApi.entities.getProductRef(e) === product.coreProductId);
  return entitiesOfProductInScene.some(
    e =>
      e.getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
        ?.highestPriorityConnection?.guestConnector.key === 'wall-corner'
  );
};

export const notPlacedInCorner = (product: Product, coreApi: CoreApi) => {
  const entitiesOfProductInScene = coreApi.entities
    .getAll()
    .filter(e => coreApi.entities.getProductRef(e) === product.coreProductId);
  return (
    entitiesOfProductInScene.length > 0 &&
    !entitiesOfProductInScene.every(
      e =>
        e.getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
          ?.highestPriorityConnection?.guestConnector.key === 'wall-corner'
    )
  );
};
